<template>
    <div ref="startPage" class="start-page">  
        <div class="simulator-container">
                <TerminalSimulator 
                    referrer="homepage"
                    text="<h1>Herzlich willkommen auf der persönlichen Website von Azad Barkho</h1>
                        <br><br>
                        <p>Ein leidenschaftlicher Anwendungsentwickler.</p>" 
                    :isWritten="pageLoadingStore.isLoaded('homepage')" 
                    @textIsWritten="pageLoadingStore.setLoaded('homepage',true)"
                />
        </div> 
    </div>
    
</template>

<script>
    import TerminalSimulator from '../components/TerminalSimulator.vue';
    import { usePageLoadingStore } from '../stores/pageLoadingStore.js'

    export default {
        __name: 'HomePage',
        props: {
            title:String,
            content:String,
            size:Number
        },
        components: {
            TerminalSimulator
        },
        setup(){
            const pageLoadingStore = usePageLoadingStore();
            return {
                pageLoadingStore
            };        
        },
        data() {
            return {
                headlineReady: false,
                contentReady: false,
            };
        },
        methods: {
            pushNextContent() {
                //console.log(this.$refs.startPage.appendChild(document.createElement('p').innerText='test'))
            }
        },

    }
</script>

<style>
    @font-face {
        font-family: orbitron;
        src: url('../../public/assets/fonts/Orbitron-Bold.ttf');
    }
</style>
<style scoped>

    .start-page{
        color: rgb(255, 255, 255);
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-weight: bolder;
        font-family: orbitron;
        font-size: v-bind(size+"px");
        position: absolute;
        top: 50%;
        bottom: 50%;
        text-align: center;
        /* transform: translateX(-50%); */
    }
</style>

<style>
    .simulator-container {
        h1{
            font-size: x-large;
            background-color: #00000069;
            display: inline;
        }
        p{
            font-size: large;
            background-color: #00000069;
            display: inline;
        }
    }
</style>